import { detect, detectOS } from "detect-browser";
import DeviceTypes from "../constants/DeviceTypes";
import { compareVersions } from "./Semver";
/**
 * Detect browser
 */
export var detectBrowser = function () {
    return detect();
};
/**
 * Detect os
 */
export var detectOs = function () {
    return detectOS(getUserAgent());
};
/**
 * Get user agent string
 */
export var getUserAgent = function () { return navigator && navigator.userAgent; };
/**
 * Is device a mobile device? (includes most tablets as well since tablets are hard to distinct...).
 */
export var isMobile = function () {
    return accept(["Android", "iPhone", "iPod", "BlackBerry", "Windows Phone"], getUserAgent());
};
/**
 * Is device a desktop device
 */
export var isDesktop = function () {
    return !isMobile() && !isTablet();
};
/**
 * Is a tablet device?
 * @Todo: find a reliable check
 */
export var isTablet = function () {
    return accept(["iPad"], getUserAgent());
};
/**
 * getDeviceType
 * Resolves the name of the device
 */
export var getDeviceType = function () {
    return isMobile() ? DeviceTypes.Mobile : isTablet() ? DeviceTypes.Tablet : DeviceTypes.Desktop;
};
/**
 * matches
 * Helper method to determine whether a given browser (or the current detected browser)
 * matches the given browser criteria
 * @param browser
 * @param criteria
 */
export var matches = function (browser, criteria) {
    if (browser === void 0) { browser = detectBrowser(); }
    // allowed: "<", "<=", ">", ">=", "="
    var operatorRegex = /^(<=|>=|~|<|>|=)([0-9.]+)/;
    return (Object.keys(criteria).find(function (os) {
        if (os !== "*" && os !== (browser === null || browser === void 0 ? void 0 : browser.os)) {
            return false;
        }
        return (Object.keys(criteria[os]).find(function (name) {
            var versions = criteria[os][name];
            if (name === (browser === null || browser === void 0 ? void 0 : browser.name)) {
                return (versions.find(function (versionPattern) {
                    var matched = versionPattern.match(operatorRegex);
                    var operator = matches && matched[1];
                    var version = matches && matched[2];
                    switch (operator) {
                        case "<":
                            return compareVersions(browser === null || browser === void 0 ? void 0 : browser.version, version) === -1;
                        case ">":
                            return compareVersions(browser === null || browser === void 0 ? void 0 : browser.version, version) === 1;
                        case "<=":
                            return compareVersions(browser === null || browser === void 0 ? void 0 : browser.version, version) < 1;
                        case ">=":
                            return compareVersions(browser === null || browser === void 0 ? void 0 : browser.version, version) > -1;
                        case "=":
                        default:
                            return compareVersions(browser === null || browser === void 0 ? void 0 : browser.version, version) === 1;
                    }
                }) !== undefined);
            }
            return false;
        }) !== undefined);
    }) !== undefined);
};
/**
 * Private functions
 */
var accept = function (patterns, value) {
    return patterns.find(function (pattern) { return value.match(new RegExp(pattern, "i")) !== null; }) !== undefined;
};
//# sourceMappingURL=BrowserDetect.js.map